import React from 'react'
import PropTypes from 'prop-types'

import UI5CalendarDay from "./day/day"

export default function UI5CalendarMonthDays(props) {
    return (
        <div className="month-days">
            {_.map(props.calendar.currentMonthDays, (day, key)=>
                <UI5CalendarDay key             = {key}
                                data            = {day}
                                dndManager      = {props.dndManager}
                                calendarDayDnd  = {props.calendarDayDnd}
                                onHighlightDate = {props.onHighlightDate}
                                onClick         = {props.onSelect}/>)}
        </div>
    )
}

UI5CalendarMonthDays.propTypes = {
    calendar        : PropTypes.object,
    dndManager      : PropTypes.object,
    calendarDayDnd  : PropTypes.func,   // special class to override control for drop into calendar days

    onHighlightDate : PropTypes.func,
    onSelect        : PropTypes.func,
}